import { setTimeout } from 'timers';
import Logger from './logger';

export default class DOM {
    static onWindowLoad(callback) {
        Logger.log('onWindowLoad: document.readyState=' + document.readyState);

        const callbackWrapper = () => {
            Logger.log('onWindowLoad: loading...');
            callback();
        };

        const addEvent = () => {
            window.addEventListener('load', callbackWrapper);
        };

        if (document.readyState === 'complete' || document.readyState === 'interactive') {
            setTimeout(callbackWrapper, 1);
        } else if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', addEvent);
        } else {
            addEvent();
        }
    }

    static createElement({ name, id, appendToId }) {
        let element = document.getElementById(id);

        if (!element) {
            element = document.createElement(name);
            element.id = id;
            if (appendToId) {
                const parent = document.getElementById(appendToId);
                if (parent) {
                    parent.appendChild(element);
                } else {
                    document.body.appendChild(element);
                }
            } else {
                document.body.appendChild(element);
            }
            return element;
        } else {
            return element;
        }
    }

    static calculateElementSize(elementId) {
        let elementHeight, elementMarginHeight, elementWidth, elementMarginWidth;
        const element = document.getElementById(elementId);

        elementHeight = parseInt(
            document.defaultView
                .getComputedStyle(element, '')
                .getPropertyValue('height')
                .replace('px', '')
        );

        elementWidth = parseInt(
            document.defaultView
                .getComputedStyle(element, '')
                .getPropertyValue('width')
                .replace('px', '')
        );

        elementMarginHeight =
            parseInt(
                document.defaultView.getComputedStyle(element, '').getPropertyValue('margin-top')
            ) +
            parseInt(
                document.defaultView.getComputedStyle(element, '').getPropertyValue('margin-bottom')
            );

        elementMarginWidth =
            parseInt(
                document.defaultView.getComputedStyle(element, '').getPropertyValue('margin-right')
            ) +
            parseInt(
                document.defaultView.getComputedStyle(element, '').getPropertyValue('margin-left')
            );

        if (!elementHeight || !elementWidth) {
            return {
                height: 0,
                width: 0
            };
        } else {
            return {
                height: elementHeight + elementMarginHeight,
                width: elementWidth + elementMarginWidth
            };
        }
    }

    static getDocumentSize() {
        const html = document.documentElement;

        const width = html.offsetWidth,
            height = html.clientHeight;

        return { width, height };
    }

    static getElementPosition(obj) {
        if (obj.getBoundingClientRect) {
            const box = obj.getBoundingClientRect();
            const body = document.body;
            const docElem = document.documentElement;
            const scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
            const scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;
            const clientTop = docElem.clientTop || body.clientTop || 0;
            const clientLeft = docElem.clientLeft || body.clientLeft || 0;
            const top = box.top + scrollTop - clientTop;
            const left = box.left + scrollLeft - clientLeft;
            return { x: Math.round(left), y: Math.round(top) };
        } else {
            let curleft = 0;
            let curtop = 0;
            if (obj.offsetParent) {
                do {
                    curleft += obj.offsetLeft;
                    curtop += obj.offsetTop;
                    obj = obj.offsetParent;
                } while (obj);
                return { x: curleft, y: curtop };
            }
        }
        return null;
    }

    static getElementHeight(obj) {
        if (!obj) return 0;
        if (obj.getBoundingClientRect) {
            const box = obj.getBoundingClientRect();
            return box.height;
        } else {
            return obj.offsetHeight;
        }
    }

    static getElementWidth(obj) {
        if (!obj) return 0;
        if (obj.getBoundingClientRect) {
            const box = obj.getBoundingClientRect();
            return box.width;
        } else {
            return obj.offsetWidth;
        }
    }

    static getElementSize(obj) {
        if (!obj) {
            return { width: 0, height: 0 };
        }
        if (obj.getBoundingClientRect) {
            const box = obj.getBoundingClientRect();
            return { width: box.width, height: box.height };
        } else {
            return { width: obj.offsetWidth, height: obj.offsetHeight };
        }
    }
}
